import { Backdrop, Box, CircularProgress } from '@mui/material';
import AgreementsTable from 'components/ppa/AgreementsTable';
import TradePopup from 'components/ppa/TradePopup';
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useApiService } from "../../services/ApiService/ApiService";

function PPAListPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const [agreements, setAgreements] = useState([]) as any;
    const [isDisabled] = useState<boolean>(false);
    const [isTradePopupOpen, setIsTradePopupOpen] = useState(false);  // Controls TradePopup visibility
    const [currentBalanceInKWh, setCurrentBalanceInKWh] = useState(0);
    const [endDate, setEndDate] = useState('');
    const [currentPPA, setCurrentPPA] = useState('');
    const { fetchWithAuth } = useApiService();

    // Method to open the TradePopup
    const openTrade = (balance: number, endDate: string, uuid: string) => {
        setCurrentBalanceInKWh(balance);
        setEndDate(endDate);
        setCurrentPPA(uuid);
        setIsTradePopupOpen(true);
    };

    // Method to close the TradePopup
    const closeTradePopup = () => {
        setIsTradePopupOpen(false);
    };
    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    useEffect(() => {
        const fetchAgreements = async () => {
            try {
                const response = await fetchWithAuth('/ppa/advanced/agreement/list', {
                    method: 'POST',
                    body: JSON.stringify({
                        uuid: userInfo.uuid,
                        businessUuid: userInfo.businessUuid
                    })
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch agreements');
                }

                const res_json = await response.json();
                res_json.agreements = checking_null_undefined(res_json.agreements);
                setAgreements(res_json.agreements.map((e: any) => ({ ...e, id: e.uuid })));
            } catch (error) {
                console.error('Error fetching agreements:', error);
                toast.error('Failed to load agreements');
            } finally {
                setLoading(false);
            }
        };

        if (userInfo.uuid && userInfo.businessUuid) {
            fetchAgreements();
        }
    }, [userInfo]);

    async function requestTrade(amountKWh: number) {
        setLoading(true);
        try {
            const response = await fetchWithAuth('/ppa/advanced/trade/create', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid,
                    powerPurchaseAgreementUuid: currentPPA,
                    amountKWh: amountKWh.toString()
                })
            });

            if (!response.ok) {
                throw new Error('Failed to create trade');
            }

            toast.success('Trade register successful', {
                position: 'bottom-center',
                duration: 5000,
            });
            setIsTradePopupOpen(false);
        } catch (error) {
            console.error('Error creating trade:', error);
            toast.error('Unable to register Trade at this time.', {
                position: 'bottom-center',
                duration: 5000,
            });
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }

    // useEffect(() => {
    //     fetchAgreements();
    // }, []);

    return (
        <div>
            <TradePopup open={isTradePopupOpen} handleClose={closeTradePopup} handleContinue={requestTrade} currentBalanceInKWh={currentBalanceInKWh} endDate={endDate} />
            <div className="container-fluid g-0" style={{ marginTop: "24px" }}>
                <div className="row gy-2">
                    <div className="drag-drop-container">
                        <AgreementsTable agreements={agreements} openTrade={openTrade} />
                    </div>
                </div>
            </div>

        </div>
    );
}


export default PPAListPage;
